'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { RatesAndFeesLink } from '../../RatesAndFeesLink';
import type { CtaAnalyticsProps } from '../../types';
export function RatesAndFeesAnalyticsLink(t0) {
  const $ = _c(12);
  const {
    analytics,
    href,
    versionId,
    actionSection,
    name
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t1;
  if ($[0] !== skuImpressionId) {
    t1 = {
      sku_impression_id: skuImpressionId
    };
    $[0] = skuImpressionId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== actionSection || $[3] !== t1) {
    t2 = {
      actionName: "rates_and_fees",
      actionSection,
      actionType: "open",
      additionalAttributes: t1
    };
    $[2] = actionSection;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fireRatesAndFeesPageAction = usePageAction(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "[1rem]"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== analytics || $[7] !== fireRatesAndFeesPageAction || $[8] !== href || $[9] !== name || $[10] !== versionId) {
    t4 = <RatesAndFeesLink analytics={analytics} href={href} versionId={versionId} onClickAnalyticsCallback={fireRatesAndFeesPageAction} containerCssProps={t3} name={name}>{"View Rates & Fees"}</RatesAndFeesLink>;
    $[6] = analytics;
    $[7] = fireRatesAndFeesPageAction;
    $[8] = href;
    $[9] = name;
    $[10] = versionId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}